import { IAlbum } from "../../common/Album";

const album: IAlbum = {
  title: "Open Source",
  date: new Date(2024, 0, 29),
  img: "/img/barn.jpeg",
  video: "/videos/barn.mp4",
  tracks: [
    {
      title: "Under Way",
      src: "/songs/2024-01-29/under_way.mp3",
      duration: 991.08,
    },
    {
      title: "Open The Barn Doors",
      src: "/songs/2024-01-29/open_the_barn_doors.mp3",
      duration: 737.16,
    },
    {
      title: "Heartbeat",
      src: "/songs/2024-01-29/heartbeat.mp3",
      duration: 743.976,
    },
    {
      title: "Almost On Purpose",
      src: "/songs/2024-01-29/almost_on_purpose.mp3",
      duration: 721.008,
    },
    {
      title: "We Walk Hand In Hand",
      src: "/songs/2024-01-29/we_walk_hand_in_hand.mp3",
      duration: 857.856,
    },
    {
      title: "Slow Motion",
      src: "/songs/2024-01-29/slow_motion.mp3",
      duration: 724.512,
    },
    {
      title: "I Don't Know Your Name",
      src: "/songs/2024-01-29/i_dont_know_your_name.mp3",
      duration: 828.168,
    },
    {
      title: "Into The Milky Way",
      src: "/songs/2024-01-29/into_the_milky_way.mp3",
      duration: 504.504,
    },
    {
      title: "Martin The Lightbringer",
      src: "/songs/2024-01-29/martin_the_lightbringer.mp3",
      duration: 695.136,
    },
    {
      title: "We're In The Dark",
      src: "/songs/2024-01-29/were_in_the_dark.mp3",
      duration: 567.816,
    },
    {
      title: "Alex Or Alec",
      src: "/songs/2024-01-29/alex_or_alec.mp3",
      duration: 271.44,
    },
    {
      title: "Warrior Spirit",
      src: "/songs/2024-01-29/warrior_spirit.mp3",
      duration: 461.472,
    },
    {
      title: "Breathe Together",
      src: "/songs/2024-01-29/breathe_together.mp3",
      duration: 563.616,
    },
  ],
};
export default album;
